import * as React from 'react'

export default function SvgSeta({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="254"
      height="179"
      fill="none"
      viewBox="0 0 254 179"
      className={className}
    >
      <title>Seta</title>
      <g filter="url(#filter0_d_406_81)">
        <path
          fill="url(#paint0_linear_406_81)"
          d="M129.475 66.525a3.5 3.5 0 0 0-4.95 0L102.251 88.8a3.5 3.5 0 1 0 4.95 4.95L127 73.949l19.799 19.8a3.5 3.5 0 0 0 4.95-4.95zM130.5 159V69h-7v90z"
        />
      </g>
      <mask
        id="mask0_406_81"
        width="254"
        height="165"
        x="0"
        y="10"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
      >
        <path
          fill="#fff"
          d="M0 30c0-11.046 8.954-20 20-20h214c11.046 0 20 8.954 20 20v125c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20z"
        />
      </mask>
      <g filter="url(#filter1_d_406_81)" mask="url(#mask0_406_81)">
        <path
          fill="url(#paint1_linear_406_81)"
          d="M129.475-30.475a3.5 3.5 0 0 0-4.95 0L102.251-8.2a3.5 3.5 0 1 0 4.95 4.95L127-23.051l19.799 19.8a3.5 3.5 0 0 0 4.95-4.95zM130.5 46v-74h-7v74z"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_406_81"
          x1="127.5"
          x2="127.5"
          y1="159"
          y2="69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0.3" />
          <stop offset="0.135" stopColor="#FBF7FE" />
          <stop offset="0.605" stopColor="#C090F2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_406_81"
          x1="127.5"
          x2="127.5"
          y1="46"
          y2="-28"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.025" stopColor="#FBF7FE" stopOpacity="0.3" />
          <stop offset="0.205" stopColor="#FBF7FE" />
          <stop offset="0.425" stopColor="#C090F2" />
        </linearGradient>
        <filter
          id="filter0_d_406_81"
          width="91.347"
          height="133.3"
          x="81.327"
          y="45.6"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="9.95" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_406_81"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_406_81"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_406_81"
          width="70.747"
          height="96.7"
          x="91.627"
          y="-41.1"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_406_81"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_406_81"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
